import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';
import config from '../../config/config';

export const generalInformationAPI = createApi({
  reducerPath: 'generalInformation',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),

  keepUnusedDataFor: 900,
  tagTypes: ['generalInformation'],
  endpoints: (builder) => ({
    getGeneralInformation: builder.query<any, UserSpecificArgTypes>({
      query: ({ affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/profile/summary
`,
        method: 'GET',
      }),
      providesTags: ['generalInformation'],
    }),

    createGeneralInformation: builder.mutation<any, GeneralInformationArgsTypes>({
      query: ({ affiliateCode, aboNumber, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/profile/summary
  `,
        method: 'POST',
        data: payload,
      }),
      invalidatesTags: ['generalInformation'],
    }),

    getOptionMasterTimeZone: builder.query<any, GetOptionMasterFilterType>({
      query: ({ filterTypeName }) => ({
        url: `/admin/optionmasters/application/amw/name/${filterTypeName}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetGeneralInformationQuery,
  useCreateGeneralInformationMutation,
  useGetOptionMasterTimeZoneQuery,
} = generalInformationAPI;
